/**
 * 科目与课程 SKU 枚举中文标签映射（subject-course-sku change 2-5）。
 *
 * 文案对齐原型 `prototype/shared/src/utils/labels.ts`，禁止各页面自行翻译，
 * 确保学段/售卖形态/上下架状态等术语三端一致。
 */
import type {
  DeductionUnit,
  GradeStage,
  ShelfStatus,
} from './course-skus.api';
import type { SkuChargeMode } from './products.api';
import type { SubjectStatus } from './subjects.api';

/** 学段中文标签（gradeStage）。 */
export const gradeStageLabel: Record<GradeStage, string> = {
  PRESCHOOL: '学前',
  PRIMARY_LOW: '小学低年级',
  PRIMARY_HIGH: '小学高年级',
  JUNIOR: '初中',
  SENIOR: '高中',
};

/** 性别中文标签（gender，对齐原型 utils/labels.ts）。 */
export const genderLabel: Record<string, string> = {
  MALE: '男',
  FEMALE: '女',
};

/**
 * 售卖形态中文标签（商品 SKU 配置行 chargeMode；O-14 起形态归商品配置行，
 * 原 SKU 级 MONTHLY/TERM 预留值废止收敛）。
 */
export const chargeModeLabel: Record<SkuChargeMode, string> = {
  SESSION_PACKAGE: '课时包',
  PERIOD: '期限卡',
};

/** 扣减单位中文标签（deductionUnit，一期恒按次）。 */
export const deductionUnitLabel: Record<DeductionUnit, string> = {
  PER_SESSION: '按次',
};

/** 课程 SKU 上下架状态中文标签（shelfStatus）。 */
export const shelfStatusLabel: Record<ShelfStatus, string> = {
  DRAFT: '草稿',
  ON_SHELF: '上架',
  OFF_SHELF: '已下架',
  DISABLED: '已停用',
};

/** 科目状态中文标签（subjectStatus）。 */
export const subjectStatusLabel: Record<SubjectStatus, string> = {
  ACTIVE: '正常',
  DISABLED: '已停用',
};

/** 由枚举值与标签映射构造下拉选项数组。 */
export function toSelectOptions<T extends string>(
  labelMap: Record<T, string>,
): Array<{ value: T; label: string }> {
  return (Object.keys(labelMap) as T[]).map((value) => ({
    value,
    label: labelMap[value],
  }));
}
